
class AnnotationAPI {

    constructor(baseUrl) {
        this.baseUrl = baseUrl + 'annotations/';
        this.headers = {
                'Content-Type': 'Application/JSON',
                'X-CSRFTOKEN': this.get_csrf_token()
            }
    }

    create_annotation(annotation) {
        annotation = this.with_props(annotation, ['timestamp', 'videoTime', 'comments', 'levelRecord', 'action']);
        const request = new Request(this.baseUrl, {
            method: 'POST',
            credentials: 'include',
            headers: this.headers,
            body: JSON.stringify(annotation)
        })
        return fetch(request)
    }

    update_annotation(annotation) {
        annotation = this.with_props(annotation, ['id', 'timestamp', 'videoTime', 
                'comments', 'levelRecord', 'action']);
        const request = new Request(this.baseUrl + annotation.id + '/', {
            method: 'PUT',
            credentials: 'include',
            headers: this.headers,
            body: JSON.stringify(annotation)
        })
        return fetch(request)
    }

    delete_annotation(annotation) {
        annotation = this.with_props(annotation, ['id']);
        const request = new Request(this.baseUrl + annotation.id + '/', {
            method: 'DELETE',
            credentials: 'include',
            headers: this.headers
        })
        return fetch(request)
    }

    // Ensures that the required properties are present and then returns an object with only those
    with_props(obj, keys) {
        keys.forEach(key=> {
            if (obj[key] === undefined) {
                throw new Error("Required property " + key + " missing.");
            }
        })
        return keys.reduce((result, key) => {result[key] = obj[key]; return result;}, {});
    }

    get_csrf_token() {
        return document.cookie.match(/csrftoken=(\w+)/)[1]
    }

}

class LevelRecordAPI {
    constructor(baseUrl) {
        this.baseUrl = baseUrl + 'level_records/';
        this.headers = {
                'Content-Type': 'Application/JSON',
                'X-CSRFTOKEN': this.get_csrf_token()
        }
    }
    level_started(lrID) {
        const request = new Request(this.baseUrl + lrID + '/started/', {
            method: 'PUT',
            credentials: 'include',
            headers: this.headers
        })
        return fetch(request)
    }
    level_complete(lrID) {
        const request = new Request(this.baseUrl + lrID + '/complete/', {
            method: 'PUT',
            credentials: 'include',
            headers: this.headers
        })
        return fetch(request)
    }
    get_csrf_token() {
        return document.cookie.match(/csrftoken=(\w+)/)[1]
    }
}

class StudentAPI {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
        this.headers = {
                'Content-Type': 'Application/JSON',
                'X-CSRFTOKEN': this.get_csrf_token()
        }
    }
    get_profile() {
        const request = new Request(this.baseUrl + 'student/profile/', {
            method: 'GET',
            credentials: 'include',
            headers: this.headers
        })
        return fetch(request)
    }
    post_coin(coins) {
        const request = new Request(this.baseUrl + 'student/post-coins/', {
            method: 'POST',
            credentials: 'include',
            headers: this.headers,
            body: JSON.stringify({ coins }),
        })
        return fetch(request)
    }
    get_csrf_token() {
        return document.cookie.match(/csrftoken=(\w+)/)[1]
    }
}

export {AnnotationAPI, LevelRecordAPI, StudentAPI};



// WEBPACK FOOTER //
// ./src/api.js